/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $StaffSurveyFormQuestion = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        formId: {
    type: 'number',
    isRequired: true,
},
        questionId: {
    type: 'number',
    isRequired: true,
},
        departmentId: {
    type: 'number',
    isNullable: true,
},
        title: {
    type: 'string',
    isRequired: true,
},
        subTitle: {
    type: 'string',
    isRequired: true,
},
        isRequired: {
    type: 'boolean',
    isRequired: true,
},
        sortOrder: {
    type: 'number',
    isRequired: true,
},
        createdAt: {
    type: 'string',
    isRequired: true,
    format: 'date-time',
},
        archivedAt: {
    type: 'string',
    isNullable: true,
    format: 'date-time',
},
    },
};